import { useQuery } from '@tanstack/react-query';

import { getTRPCClient } from '../config';

export function useGasActivities() {
  const trpc = getTRPCClient();
  return useQuery({
    ...trpc.gas.getGasActivities.queryOptions(undefined, {
      staleTime: 60 * 1000,
    }),
  });
}
